module.exports = __webpack_public_path__ + "img/solution-data-logo8.79237024.png";